import React, { useState } from 'react';
import styles from './Programs.module.css';

// Components
import SearchBar from '../../../components/SearchBar/SearchBar';
import Dropdown from '../../../components/Dropdown/Dropdown';
import DynamicTable from '../../../components/DynamicTable/DynamicTable';
import PaginationTable from '../../../components/PaginationTable/PaginationTable';

const Programs = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(3);
  const [selectedIds, setSelectedIds] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedLabel, setSelectedLabel] = useState(null); // null = "All Labels"

  const data = [
    {
      _id: 'p1',
      name: 'Murali',
      status: 'Expired',
      stage: 'Completed',
      dateRange: '02/06/2025 - 10/06/2025',
      daysOfWeek: ['Mon', 'Tue', 'Wed', 'Thurs'],
      label: 'Eee',
    },
    {
      _id: 'p2',
      name: 'Murali',
      status: 'Expired',
      stage: 'Completed',
      dateRange: '02/06/2025 - 10/06/2025',
      daysOfWeek: ['Mon', 'Tue', 'Wed', 'Thurs'],
      label: 'ABC',
    },
    {
      _id: 'p3',
      name: 'Murali',
      status: 'Expired',
      stage: 'Completed',
      dateRange: '02/06/2025 - 10/06/2025',
      daysOfWeek: ['Mon', 'Tue', 'Wed', 'Thurs'],
      label: 'Eee',
    },
  ];

  const labelOptions = ['Eee', 'ABC']; // Don't include "All Labels"

  const headings = [
    {
      title: (
        <input
          type="checkbox"
          checked={selectedIds.length === data.length}
          onChange={(e) => {
            if (e.target.checked) {
              setSelectedIds(data.map((item) => item._id));
            } else {
              setSelectedIds([]);
            }
          }}
        />
      ),
      accessor: 'checkBox',
    },
    { title: 'Programs', accessor: 'program' },
    { title: 'Programs stage', accessor: 'stage' },
    { title: 'Date Range', accessor: 'dateRange' },
    { title: 'Days Of Week', accessor: 'daysOfWeek' },
    { title: 'Labels', accessor: 'label' },
  ];

  const filteredData = data.filter((item) => {
    const matchesSearch = item.name
      .toLowerCase()
      .includes(searchTerm.toLowerCase());
    const matchesLabel = !selectedLabel || item.label === selectedLabel;
    return matchesSearch && matchesLabel;
  });

  const columnData = filteredData.map((item) => {
    const isChecked = selectedIds.includes(item._id);
    return {
      checkBox: (
        <input
          type="checkbox"
          checked={isChecked}
          onChange={(e) => {
            const checked = e.target.checked;
            if (checked) {
              setSelectedIds((prev) => [...prev, item._id]);
            } else {
              setSelectedIds((prev) => prev.filter((id) => id !== item._id));
            }
          }}
        />
      ),
      program: (
        <div className={styles.programCell}>
          <span>{item.name}</span>
          <span className={styles.expired}>
            <span className={styles.dot}></span>
            {item.status}
          </span>
        </div>
      ),
      stage: item.stage,
      dateRange: item.dateRange,
      daysOfWeek: (
        <div className={styles.daysContainer}>
          {item.daysOfWeek.map((day, i) => (
            <span
              key={i}
              className={`${styles.day} ${styles[day.toLowerCase()]}`}
            >
              {day}
            </span>
          ))}
        </div>
      ),
      label: item.label,
    };
  });

  return (
    <div className={styles.Programs}>
      <div className={styles.topBar}>
        <SearchBar
          placeholder="Search Program"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        <Dropdown
          label="Labels"
          options={labelOptions}
          onChange={(val) => setSelectedLabel(val)}
        />
      </div>

      <div className={styles.tableWrapper}>
        <DynamicTable
          headings={headings}
          columnData={columnData.slice(
            (currentPage - 1) * itemsPerPage,
            currentPage * itemsPerPage
          )}
        />
        <PaginationTable
          data={columnData}
          currentPage={currentPage}
          itemsPerPage={itemsPerPage}
          setCurrentPage={setCurrentPage}
          setItemsPerPage={setItemsPerPage}
        />
      </div>
    </div>
  );
};

export default Programs;
